import { Module } from '../Module';
import { ILogo, LogoService } from '../services/LogoService';

export interface ISignInLogoScope extends ng.IScope {
  signInLogo: ILogo;
}

Module.instance().directive('tbSignInLogo', [
  'LogoService',
  (LogoService: LogoService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'signInLogo.html',
      link: (scope: ISignInLogoScope, element: JQuery, attributes: ng.IAttributes) => {
        scope.signInLogo = LogoService.getSignInLogo();
      }
    };
  }
]);
